module.exports = __webpack_public_path__ + "static/media/mars7.f9354f0a.jpg";